// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { css } from '@microsoft/fast-element';
import { BaseFieldStyles } from '../styles/index.js';
/**
 * Styles for Date Field
 * @public
 */
export const dateFieldStyles = (context, definition) => css `
  ${BaseFieldStyles}
`;
